import { carregarMotivosPadraoDaStore } from '@/integracoes/src-next/catalogos/catalogo-motivo-padrao.vuex'
import { CAMPOS_PROJECAO_MOTIVO_PADRAO } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/catalogo-motivo-padrao.tipos'
import { freezeItems } from './freezeItems'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    onlyForJustify (state) {
      return state.items.filter(i => i.active === true && i.kind === 'justify')
    },
    onlyForFakePts (state) {
      return state.items.filter(i => i.active === true && i.kind === 'faketimelog_reason')
    },
    justificativaEPontosFake (state) {
      return state.items.filter(i => i.active === true && ['justify', 'faketimelog_reason'].includes(i.kind))
    },
    apenasParaGerenciamentoDeArquivo (state) {
      return state.items.filter(i => i.active === true && i.kind === 'aprovacao_de_arquivo')
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
    },
    resetItems (state) {
      state.items = []
      state.loading = false
      state.pronto = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ state, dispatch }, payload = {}) {
      if (payload.id !== undefined || payload.page !== undefined || payload.search !== undefined || payload.kind !== undefined || (payload.withFields || []).some(campo => !CAMPOS_PROJECAO_MOTIVO_PADRAO.includes(campo)) || payload.fields !== undefined) {
        return dispatch('consultarItensEspecificos', payload)
      }
      await carregarMotivosPadraoDaStore(this, payload.fullReload === true)
      const active = payload.active === false || payload.active === 'false' ? false : true
      return state.items.filter(item => item.active === active)
    },
    async consultarItensEspecificos (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const { withFields, ...parametros } = payload
      delete parametros.fullReload
      if (withFields) parametros.fields = JSON.stringify([...new Set([...CAMPOS_PROJECAO_MOTIVO_PADRAO, ...withFields])])
      const resposta = await retryRequest(API.reason.get, parametros)
      return resposta.status === 204 ? [] : (resposta.body.success || [])
    }
  }
}
